import { headingText } from '../utils/headingText';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Footer from '../components/Footer';
export default function NotFound() {
  return <><SEO title="Page not found" description="This page could not be found. Explore Sync Strategic's services or get in touch." noindex /><main className="home-wrap home-section"><p className="eyebrow">404</p><h1 className="text-5xl font-bold mb-6">{headingText("Let’s get you back on track.")}</h1><p className="mb-8">We couldn’t find that page.</p><Link to="/" className="action-dark">Back to home</Link></main><Footer /></>;
}
